// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1a204d","secondary":"#ddd","progressBar":"#ff00fa"};